export default __webpack_public_path__ + "static/media/轮播首图9.7714d76c.jpg";